import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, IconButton } from "@mui/material";
import TextInput from "../../Components/InputComponents/TextInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useNavigate, useParams } from "react-router-dom";
import {
  errorNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import { decryptId } from "../../Components/CryptoComponent";

const EditRole = () => {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);

  const [data, setData] = useState({
    RL_Name: "",
    RL_Status: 1,
  });

  const getData = () => {
    axiosAPI
      ?.get(`/UserRole/listbyid/${decryptedId}`)
      .then((res) => {
        setData({
          RL_Name: res?.data?.data?.RL_Name,
          RL_Status: res?.data?.data?.RL_Status,
        });
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const [errors, setErrors] = useState({});

  // Validate the form fields
  const validateForm = () => {
    const mandatoryFields = [
      {
        field: "RL_Name",
        label: "Role Name",
      },
      {
        field: "RL_Status",
        label: "Role Status",
      },
    ];

    let formErrors = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{10}$/; // 10-digit phone validation

    for (let { field, label, type } of mandatoryFields) {
      const value = data[field];

      if (!value) {
        formErrors[field] = `${label} is required.`;
      } else if (type === "email" && !emailRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      } else if (type === "phone" && !phoneRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      }
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      // Display the errors as toast notifications
      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });
      return false;
    }

    return true;
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });

    setData({
      ...data,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      axiosAPI
        ?.post(`/UserRole/edit/${decryptedId}`, data)
        .then((res) => {
          if (res?.data?.success) {
            successNotify(res?.data?.message);
            navigate(`/Roles`);
          }
        })
        .catch((err) => {
          errorNotify("Something went wrong");
        });

      //  successNotify("Role added successfully");
      //  setTimeout(() => {
      //   navigate(`/Roles`)
      //  }, 2000);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  return (
    <Paper
      sx={{
        padding: { xs: 2, sm: 3, md: 5 },
        margin: "auto",
        position: "relative",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      {/* Main Heading */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          textAlign: "left",
          marginBottom: 3,
          fontFamily: "Geist, sans-serif",
        }}
      >
        Edit Role
      </Typography>

      <Grid
        container
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Role Name <span style={{ color: "red" }}> * </span>
          </Typography>
          <TextInput
            label="Full Name"
            placeholder="Enter Full Name"
            name="RL_Name"
            value={data.RL_Name}
            onChange={handleInputChange}
            error={!!errors.RL_Name}
            loading={loader}
          />
        </Grid>

        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Status <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={data?.RL_Status}
            onChange={handleInputChange}
            options={[
              { value: "1", label: "Active" },
              { value: "0", label: "Inactive" },
            ]}
            name="RL_Status"
            placeholder="Select Status"
            error={!!errors.RL_Status}
            loading={loader}
          />
        </Grid>
      </Grid>

      {/* Buttons */}
      <Grid
        container
        spacing={2}
        justifyContent={{ xs: "center", sm: "flex-end" }}
        sx={{ mt: 3 }}
      >
        <Grid item>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() => {
              navigate(`/Roles`);
            }}
          >
            Cancel
          </CommonButton>
        </Grid>
        <Grid item>
          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={handleSubmit}
          >
            Save
          </CommonButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EditRole;
